
import { PRODUCTS } from '../constants';
import { Product } from '../types';

const ProductCard=({ product }) => {
  return (
    <div className="group glass rounded-2xl overflow-hidden transition-all duration-500 hover:shadow-[0_0_50px_rgba(212,175,55,0.15)] hover:-translate-y-2">
      <div className="relative aspect-square overflow-hidden bg-white/5">
        <img 
          src={product.imageUrl} 
          alt={product.name} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute top-4 right-4 bg-gold text-black text-[10px] font-bold px-3 py-1 uppercase tracking-widest rounded-full">
          New Arrival
        </div>
      </div>
      
      <div className="p-8">
        <h3 className="text-2xl font-serif text-white mb-2 group-hover:text-gold transition-colors">
          {product.name}
        </h3>
        <p className="text-gold text-xs font-bold uppercase tracking-widest mb-4">
          {product.tagline}
        </p>
        <p className="text-gray-400 text-sm mb-6 line-clamp-2 leading-relaxed">
          {product.description}
        </p>
        
        <div className="space-y-2 mb-8">
          {product.benefits.slice(0, 3).map((benefit, i) => (
            <div key={i} className="flex items-center space-x-2 text-xs text-gray-300">
              <i className="fas fa-check text-gold"></i>
              <span>{benefit}</span>
            </div>
          ))}
        </div>
        
        <button className="w-full py-3 bg-white/5 border border-white/10 text-white text-xs font-bold uppercase tracking-widest hover:bg-gold hover:text-black transition-all">
          View Details
        </button>
      </div>
    </div>
  );
};

const ProductSection= () => {
  return (
    <section id="products" className="py-24 bg-black relative">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-gold font-bold tracking-[0.3em] uppercase mb-4">The Collection</h2>
          <h3 className="text-4xl md:text-6xl font-serif text-white">Ayurvedic Masterpieces</h3>
          <div className="h-1 w-24 bg-gold mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {PRODUCTS.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
